<template>
  <div class="tc-project-card-group">
    <div class="tc-project-card"
         :title="item.name"
         :class="{'tc-project-card-active': isActive}"
         @click="$emit('selectToolChest')">
      <img class="tc-project-card-image"
           :src="getImage(item.image)"
           alt="caseImg">
      <div class="tc-project-card-header">
        <div class="tc-project-card-label">
          {{ item.name }}
        </div>
        <div class="tc-project-card-options"
             v-if="isValidatedRole"
             @click.stop="setIsShowContext(!isShowContext)">
          <SVGOptions/>
        </div>
      </div>
      <div v-if="useStoreProjectStructure().checkIsDefaultColorById(item.id)" class="tc-project-card-price">
        {{ item.cost }} {{ currencySymbol }}
      </div>
      <div  v-if="!useStoreProjectStructure().checkIsDefaultColorById(item.id)" class="tc-project-card-price">
        Рассчитывается индивидуально
      </div>
      <div class="tc-project-card-date">
        <!--            {{item.date}}-->
        {{ getHumanDate(item.date) }}
      </div>
      <div class="tc-project-card-counter-container">
        <ItemCounter :number="storeProjectStructure.getCaseById(item.id)?.count ?? 0"
                     :min-value="1"
                     @change="(value) => storeProjectStructure.setCaseCountById(item.id, value)"
                     @decrease="storeProjectStructure.setCaseCountById(item.id, +item.count - 1,)"
                     @increase="storeProjectStructure.setCaseCountById(item.id, +item.count + 1,)"/>
      </div>
    </div>
    <ProjectContext v-if="isShowContext && isValidatedRole"
                    @delete="deleteCase(item.id)"
                    @rename="renameCase(item.id)"
                    @copy="copyCase(item.id)"/>
  </div>


</template>

<script>
import ItemCounter from '@/UI/CommonComponents/ItemCounter.vue';
import SVGOptions from '@/UI/SVG/SVGOptions.vue';
import { useStoreProjectStructure } from '@/Store/storeProjectStructure';
import dateFormat from 'dateformat';
import { getImage } from '@/libs/getImage';
import ProjectContext from '@/UI/LeftSidebar/Components/ProjectContext.vue';
import { useStoreUI } from '@/Store/storeUI';
import { deleteCase } from '@/libs/deleteCase';
import { useStoreCaseConfiguration } from '@/Store/storeCaseConfiguration';
import { useStoreNotifications } from '@/Store/storeNotifications';
import { generateNotification } from '@/libs/generateNotification';
import { selectCaseById } from '@/libs/selectCase';
import { useStoreRenameCase } from '@/Store/storeRenameCase';
import { roleCheck } from '@/libs/roleCheck';
import { saveProject } from '@/utils/postmessages';
import { useStoreMeta } from '@/Store/storeMeta';
import { colors } from '@/Constants/colors';

export default {
  name: 'ProjectCard',
  components: {
    ProjectContext,
    SVGOptions,
    ItemCounter,
  },
  setup() {
    const storeProjectStructure = useStoreProjectStructure();
    const storeCaseConfiguration = useStoreCaseConfiguration();
    const storeNotifications = useStoreNotifications();
    const storeUI = useStoreUI();
    const storeRenameCase = useStoreRenameCase();
    const storeMeta = useStoreMeta();
    return {
      storeProjectStructure,
      storeCaseConfiguration,
      storeNotifications,
      storeUI,
      storeRenameCase,
      storeMeta,
    };
  },
  props: [
    'isActive',
    'item',
  ],
  data() {
    return {
      isShowContext: false,
    };
  },
  methods: {
    useStoreProjectStructure,
    dateFormat,
    getImage,
    deleteCase() {
      this.storeUI.setIsContestMenuAvailable(false);

      useStoreProjectStructure().deleteCaseById(this.item.id);
      if (this.storeMeta.role) {
        saveProject();
      }

      if (this.storeProjectStructure.cases.length === 0) {
        this.$router.push({ path: '/selectCase' });
      } else if (this.item.id === this.storeProjectStructure.selectedCaseId) {
        selectCaseById(this.storeProjectStructure.cases[0].id);
      }
      this.storeNotifications
          .addNotification(generateNotification('caseDeleted', 'Шкаф удалён.'), 2);
    },
    renameCase() {
      this.storeUI.setIsContestMenuAvailable(false);
      this.storeUI.setActiveModalName('rename');
      this.storeUI.setIsShowModal(true);
      this.storeRenameCase.writeRenameCaseParams(this.item.id, this.item.name);
    },
    copyCase() {
      this.storeUI.setIsContestMenuAvailable(false);
      const newCaseId = crypto.randomUUID();
      let caseConfig = undefined;
      useStoreProjectStructure().addCase(
          {
            id: newCaseId,
            name: this.item.name + ' (Копия)',
            image: this.item.image ?? '',
            date: Date().toString(),
            cost: this.item.cost,
            count: 1,
          },
      );

      if (this.item.id === this.storeProjectStructure.selectedCaseId) {
        caseConfig = JSON.parse(JSON.stringify(this.storeCaseConfiguration.$state));
      } else {
        caseConfig = this.storeProjectStructure.getCaseDataById(this.item.id);
      }

      if (!caseConfig) {
        console.error('Конфигурация не найдена');
        return;
      }
      this.storeProjectStructure.updateCaseDataById(newCaseId, caseConfig);
      this.storeNotifications
          .addNotification(generateNotification('caseCopied', 'Создана копия шкафа.'), 2);

    },

    getHumanDate(timestamp) {
      function isDate(dateString) {
        const date = new Date(dateString);
        return !isNaN(date) && date.toString() !== 'Invalid Date';
      }

      if (isDate(timestamp)) {
        return dateFormat(new Date(timestamp), 'yyyy.mm.dd HH:MM:ss');
      } else {
        return '';
      }
    },
    setIsShowContext(status) {
      this.storeUI.setIsContestMenuAvailable(false);
      if (status) {
        this.isShowContext = true;
        this.storeUI.setIsContestMenuAvailable(true);
        // return;
      }
      // this.isShowContext = false;
    },
  },
  computed: {
    isContextMenuAvailable() {
      return this.storeUI.isContextMenuAvailable;
    },
    isValidatedRole() {
      return roleCheck([ 'dealer', 'employee', 'user' ]);
    },
    currencySymbol() {
      return this.storeMeta.currency;
    },
    isDefaultColorSettings(){
      //Мы знаем цвет только для выбранного шкафа и можем сказать про расчёт только для него
      const selectedCaseId = this.storeProjectStructure.selectedCaseId;
      if(selectedCaseId===this.item.id){
        const isColorFrameDefault=this.storeCaseConfiguration.colorFrame=== colors[0].hex;
        const isColorFaceDefault=this.storeCaseConfiguration.colorFace=== colors[1].hex;
        return isColorFrameDefault&&isColorFaceDefault;
      }
      return true;
    },
  },
  watch: {
    isContextMenuAvailable(newValue, oldValue) {
      if (!newValue) {
        this.isShowContext = false;
      }
    },
  },
  emits: [
    'selectToolChest',
  ],
};
</script>

<style scoped lang="scss">
.tc-project-card-group {
  display: flex;
  height: max-content;
  width: max-content;
  flex-direction: column;
  position: relative;
  overflow: visible;
}

.tc-project-card {
  box-sizing: border-box;
  display: flex;
  padding: 10px;
  flex-direction: column;
  align-items: center;
  height: max-content;
  font-size: 14px;
  gap: 5px;
  width: 270px;
  border: 1px solid #D9D9D9;
  cursor: pointer;
  transition: 0.3s ease all;
  position: relative;
}

.tc-project-card:hover {
  border: 1px solid #00458D;
}

.tc-project-card-active {
  border: 1px solid #00458D;
}

.tc-project-card-image {
  width: 100%;
  height: 184px;
  object-fit: cover;
  position: relative;

  background-color: #f2f2f2; // TEMP
}

.tc-project-card-header {
  display: flex;
  flex-direction: row;
  gap: 10px;
  width: 100%;
  //overflow: hidden;
  justify-content: space-between;
  box-sizing: border-box;
}

.tc-project-card-label {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
  height: max-content;
  color: #00458D;
}

.tc-project-card-options {
  width: 22px;
  height: max-content;
  color: #333333;
  position: relative;
}

.tc-project-card-price {
  color: #333333;
  font-weight: 600;
  width: 100%;
  box-sizing: border-box;
}

.tc-project-card-date {
  color: #33333380;
  width: 100%;
  box-sizing: border-box;
}

.tc-project-card-counter-container {
  padding-top: 15px;
  display: flex;
  height: max-content;
  flex: 1;
  justify-content: center;
  align-items: center;
}

</style>
